<script setup>
import { MessageCircleMoreIcon } from 'lucide-vue-next'
import Base from '@/Components/Cards/Base.vue'
import MessageUserModal from '../Conversations/MessageUserModal.vue'

defineProps({
  claim: Object,
  withActions: {
    type: Boolean,
    default: true,
  },
})
</script>

<template>
  <Base>
    <MessageUserModal
      v-if="withActions"
      :recipient="claim.user"
      trigger-class="absolute -top-2 -right-2 bg-primary rounded-full px-1.5 h-8 cursor-pointer text-white"
    >
      <MessageCircleMoreIcon class="size-5" />
    </MessageUserModal>

    <figure class="flex h-full flex-col justify-between">
      <blockquote class="font-typewriter text-sm tracking-wider text-gray-800">
        <p>{{ `“${claim.description}”` }}</p>
      </blockquote>
      <figcaption class="mt-6 flex gap-2">
        <slot name="caption" />
      </figcaption>
    </figure>
  </Base>
</template>
